export const getRatingLabelStyles = (size: 'small' | 'medium' | 'large' | undefined) => {
  return size === 'small'
    ? {
        fontSize: '14px',
        lineHeight: '20px',
      }
    : {
        fontSize: '16px',
        lineHeight: '24px',
      };
};
